import { render, staticRenderFns } from "./PageBlockConfigForm.vue?vue&type=template&id=1712ffd2"
import script from "./PageBlockConfigForm.vue?vue&type=script&lang=js"
export * from "./PageBlockConfigForm.vue?vue&type=script&lang=js"
import style0 from "./PageBlockConfigForm.vue?vue&type=style&index=0&id=1712ffd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports